import { Transform, Type } from 'class-transformer';

import { IPagination } from './utils';

export class IVehicleLocationListItem {
  id: string | number;
  vehicleId: string | number;
  date: string;

  @Transform(({ value }) => {
    return value / 10000000;
  })
  lat: number;

  @Transform(({ value }) => {
    return value / 10000000;
  })
  loc: number;

  lastdate: string;
  districtCode: number;
  cityCode: number;
}

export class IVehicleLocationListResponse extends IPagination {
  @Type(() => IVehicleLocationListItem)
  results: IVehicleLocationListItem[];
}

export interface VehicleLocationQueryParams {
  page?: number;
  limit?: number;
  orderBy?: 'asc' | 'desc';
  vehicleId?: number;
  date?: string;
  lat?: string;
  loc?: string;
  lastdate?: string;
  districtCode?: number;
  cityCode?: number;
}

export interface VehicleWithLocation {
  id: number;
  plate: string;
  name?: string;
  location?: IVehicleLocationListItem;
}
